(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ks-loyalty-coupon-guard"] && !Shopify.designMode) return;
  try {
    (() => {
  const dialog = document.getElementById('ks-coupon-guard');
  const text = document.getElementById('ks-coupon-guard-text');
  if (!dialog || !text || dialog.dataset.ready) return;
  dialog.dataset.ready = 'true';
  const labels = JSON.parse(text.textContent);
  const rootSelector = '.honeypop-cp, #honeypop-app';
  const rewardSelector = '.cp-reward-wrapper[data-reward-id="32439"]';
  const rowSelector = `.honeypop-cp ${rewardSelector}`;
  const widgetRangeSelector = 'input[type="range"][class^="_RewardSlider_"]';
  const widgetSectionSelector = 'div[class^="_Section_"]';
  const summary = dialog.querySelector('#ks-coupon-summary');
  const confirm = dialog.querySelector('[data-ks-coupon-confirm]');
  const cancel = dialog.querySelector('[data-ks-coupon-cancel]');
  const number = new Intl.NumberFormat('tr-TR', { maximumFractionDigits: 2 });
  const bindings = new WeakMap();
  const knownButtons = new WeakMap();
  const roots = new Map();
  const dirtyRoots = new Set();
  let pending = null;
  let permitted = null;
  let editingRange = null;
  let returnFocus = null;
  let submitting = null;
  let sequence = 0;

  const interpolate = (message, values) => message.replace(/\[(amount|points)\]/g, (_, key) => values[key]);

  function widgetRow(element) {
    if (!element.closest('#honeypop-app')) return null;
    const section = element.closest(widgetSectionSelector);
    return section?.textContent.replace(/\s+/g, ' ').includes(labels.rewardTitle) ? section : null;
  }

  function findRow(element) {
    return element.closest(rowSelector) || widgetRow(element);
  }

  function controls(row) {
    const kind = row.closest('#honeypop-app') ? 'widget' : 'cart';
    const range = row.querySelector(kind === 'widget' ? widgetRangeSelector : 'input[type="range"]');
    if (!range) return null;
    const previous = bindings.get(row);
    const widgetButtons = kind === 'widget' ? row.querySelectorAll('button.essential-loyalty-app-button') : null;
    const button = previous?.range === range && row.contains(previous.button)
      ? previous.button : kind === 'widget'
        ? widgetButtons.length === 1 && row.querySelectorAll(widgetRangeSelector).length === 1 ? widgetButtons[0] : null
        : range.parentElement.querySelector('button');
    if (!button) return null;
    const binding = { row, range, button, kind };
    bindings.set(row, binding);
    knownButtons.set(button, row);
    return binding;
  }

  function formatAmount(value) {
    let numeric = value.replace(/\s+(?:off|indirim)$/i, '').trim();
    if (!/₺|\bTL\b|\bTRY\b/.test(numeric)) return null;
    numeric = numeric.replace(/₺|\bTL\b|\bTRY\b|\s/g, '');
    if (!/^\d[\d.,]*$/.test(numeric)) return null;
    const decimal = numeric.match(/[.,](\d{1,2})$/);
    numeric = decimal
      ? `${numeric.slice(0, decimal.index).replace(/[.,]/g, '')}.${decimal[1]}`
      : numeric.replace(/[.,]/g, '');
    const amount = Number(numeric);
    return Number.isFinite(amount) && amount > 0 ? `${number.format(amount)} TL` : null;
  }

  function read(row) {
    const binding = controls(row);
    if (!binding) return null;
    const { range, button, kind } = binding;
    const label = kind === 'widget' ? range.parentElement.querySelector('p:not(.ks-coupon-hint)') : row.querySelector('.cp-info-label');
    const points = Number(range.value);
    const amountMatch = kind === 'widget' ? label?.textContent.match(/₺\s*[\d.,]+|[\d.,]+\s*(?:TL|TRY)\b/) : null;
    const amount = label ? formatAmount(kind === 'widget' ? amountMatch?.[0] || '' : label.textContent) : null;
    const displayedCost = kind === 'widget'
      ? amountMatch ? label.textContent.slice(0, amountMatch.index).replace(/[^0-9]/g, '') : null
      : row.firstElementChild?.lastElementChild?.textContent.replace(/[^0-9]/g, '');
    if (button.disabled || button.getAttribute('aria-disabled') === 'true' || !amount ||
        !Number.isSafeInteger(points) || points <= 0 ||
        points < Number(range.min) || points > Number(range.max) || Number(displayedCost) !== points) return null;
    return { ...binding, label, amount, points, fingerprint: [amount, points, range.min, range.max, range.step].join('|') };
  }

  function decorate(row) {
    const label = row.querySelector('.cp-info-label');
    if (label && /\soff$/.test(label.textContent.trim())) {
      label.textContent = label.textContent.trim().replace(/\soff$/, ` ${labels.discount}`);
    }
    const data = read(row);
    if (!data) return;
    if (data.kind === 'widget') data.label.classList.add('ks-coupon-native-summary');
    data.range.classList.add('ks-coupon-range');
    const buttonText = data.button.querySelector('span') || data.button;
    const busy = submitting && Date.now() < submitting.until;
    const actionText = busy ? labels.processing : labels.review;
    if (buttonText.textContent !== actionText) buttonText.textContent = actionText;
    if (busy) data.button.setAttribute('aria-busy', 'true');
    else if (data.button.getAttribute('aria-busy') === 'true') data.button.removeAttribute('aria-busy');
    data.range.setAttribute('aria-label', labels.range);
    data.range.setAttribute('aria-valuetext', `${data.amount}, ${number.format(data.points)} ${labels.pointsLabel}`);
    let hint = data.range.parentElement.querySelector('.ks-coupon-hint');
    if (!hint) {
      sequence += 1;
      hint = document.createElement('p');
      hint.className = 'ks-coupon-hint';
      hint.id = `ks-coupon-hint-${sequence}`;
      hint.textContent = labels.hint;
      data.range.before(hint);
    }
    const descriptions = new Set((data.range.getAttribute('aria-describedby') || '').split(/\s+/).filter((id) => id && !id.startsWith('ks-coupon-hint-')));
    descriptions.add(hint.id);
    data.range.setAttribute('aria-describedby', [...descriptions].join(' '));
    if (!data.range.id) data.range.id = `${hint.id}-range`;
    let selection = data.range.parentElement.querySelector('.ks-coupon-selection');
    if (!selection) {
      selection = document.createElement('output');
      selection.className = 'ks-coupon-selection';
      selection.setAttribute('aria-live', 'off');
      hint.before(selection);
    }
    selection.setAttribute('for', data.range.id);
    const selectionText = interpolate(labels.selection, { amount: data.amount, points: number.format(data.points) });
    if (selection.textContent !== selectionText) selection.textContent = selectionText;
  }

  function show(data, origin) {
    pending = data;
    const values = data ? { amount: data.amount, points: number.format(data.points) } : null;
    summary.textContent = data ? interpolate(data.kind === 'widget' ? labels.widgetSummary : labels.summary, values) : labels.unavailable;
    confirm.textContent = data ? interpolate(data.kind === 'widget' ? labels.widgetConfirm : labels.confirm, values) : '';
    confirm.hidden = !data;
    confirm.disabled = false;
    editingRange = data?.range || findRow(origin)?.querySelector('input[type="range"]');
    returnFocus = origin;
    if (typeof dialog.showModal !== 'function') {
      window.alert(labels.unavailable);
      pending = null;
      return;
    }
    dialog.showModal();
    cancel.focus();
  }

  window.addEventListener('click', (event) => {
    const button = event.target instanceof Element ? event.target.closest('button') : null;
    const row = button ? findRow(button) : null;
    if (!row) return;
    if (!row.querySelector('input[type="range"]')) return;
    const binding = controls(row);
    if (binding?.button !== button && knownButtons.get(button) !== row) return;
    if (permitted === button) { permitted = null; return; }
    event.preventDefault();
    event.stopImmediatePropagation();
    if (submitting && Date.now() < submitting.until) return;
    if (!dialog.open) show(read(row), button);
  }, true);

  cancel.addEventListener('click', () => {
    if (editingRange?.isConnected) returnFocus = editingRange;
    dialog.close();
  });
  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right ||
        event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => {
    pending = null;
    const focusTarget = returnFocus?.isConnected ? returnFocus : document.querySelector(`${rowSelector} input[type="range"], #honeypop-app ${widgetRangeSelector}`);
    focusTarget?.focus({ preventScroll: true });
    returnFocus = null;
    editingRange = null;
  });
  confirm.addEventListener('click', () => {
    if (!pending || !dialog.open) return;
    const current = pending.row.isConnected ? read(pending.row) : null;
    if (!current || current.button !== pending.button || current.range !== pending.range ||
        current.fingerprint !== pending.fingerprint) {
      pending = null;
      summary.textContent = labels.unavailable;
      confirm.hidden = true;
      cancel.focus();
      return;
    }
    pending = null;
    confirm.disabled = true;
    dialog.close();
    const submission = { until: Date.now() + 5000, button: current.button };
    submitting = submission;
    setTimeout(() => {
      if (submitting === submission) {
        current.button.removeAttribute('aria-busy');
        submitting = null;
        roots.forEach((observer, root) => update(root));
      }
    }, 5000);
    permitted = current.button;
    try { current.button.click(); } finally {
      permitted = null;
      confirm.disabled = false;
      roots.forEach((observer, root) => update(root));
    }
  });

  let scheduled = false;
  const update = (root) => {
    dirtyRoots.add(root);
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      dirtyRoots.forEach((dirtyRoot) => {
        if (!dirtyRoot.isConnected) return;
        dirtyRoot.querySelectorAll(rewardSelector).forEach(decorate);
        const widgetRows = new Set([...dirtyRoot.querySelectorAll(widgetRangeSelector)].map(widgetRow).filter(Boolean));
        widgetRows.forEach(decorate);
      });
      dirtyRoots.clear();
    });
  };

  const observeRoot = (root) => {
    if (roots.has(root)) return;
    const observer = new MutationObserver(() => update(root));
    observer.observe(root, {
      childList: true, subtree: true, characterData: true,
      attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'min', 'max', 'step']
    });
    roots.set(root, observer);
    update(root);
  };
  new MutationObserver((records) => {
    roots.forEach((observer, root) => {
      if (!root.isConnected) { observer.disconnect(); roots.delete(root); }
    });
    records.forEach((record) => {
      if (record.target instanceof Element && record.target.closest(rootSelector)) return;
      record.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;
        if (node.matches(rootSelector)) observeRoot(node);
        node.querySelectorAll(rootSelector).forEach(observeRoot);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('input', (event) => {
    if (event.target instanceof Element && findRow(event.target)) update(event.target.closest(rootSelector));
  });
  document.querySelectorAll(rootSelector).forEach(observeRoot);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ks-loyalty-placement-ux"] && !Shopify.designMode) return;
  try {
    (() => {
  const template = document.getElementById('ks-loyalty-account-link');
  if (!template?.content.firstElementChild || template.dataset.ready) return;
  template.dataset.ready = 'true';
  const number = new Intl.NumberFormat('tr-TR', { maximumFractionDigits: 0 });
  const money = new Intl.NumberFormat('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const rootSelector = '.honeypop-pp, .honeypop-cp';
  const roots = new Map();
  const pending = new Set();
  let scheduled = false;

  const attr = (element, name, value) => {
    if (element.getAttribute(name) !== value) element.setAttribute(name, value);
  };
  const removeAttr = (element, name) => {
    if (element.hasAttribute(name)) element.removeAttribute(name);
  };
  const makeStatic = (element) => {
    if (!element) return;
    ['role', 'tabindex', 'aria-expanded', 'aria-controls'].forEach((name) => removeAttr(element, name));
  };
  const hide = (element) => {
    if (!element) return;
    if (!element.hidden) element.hidden = true;
    if (!element.inert) element.inert = true;
    attr(element, 'aria-hidden', 'true');
  };
  const normalizePoints = (element) => {
    for (const node of element.childNodes) {
      if (node.nodeType !== Node.TEXT_NODE) continue;
      const value = node.nodeValue.replace(/(-?)(\d[\d.,]*)(?=\s+Küp\s+Puan)/g, (_, sign, digits) => `${sign}${number.format(Number(digits.replace(/[.,]/g, '')))}`);
      if (value !== node.nodeValue) node.nodeValue = value;
    }
  };

  function decorate(root) {
    const target = root.querySelector('.honeypop-pp-text, .honeypop-cp-text');
    if (!target) return;
    if (!root.classList.contains('ks-account-hub')) root.classList.add('ks-account-hub');
    root.querySelectorAll('.honeypop-pp-text > p, .honeypop-cp-text > p').forEach(normalizePoints);
    let actions = target.querySelector('.ks-account-hub-actions');
    if (!actions) {
      actions = template.content.firstElementChild.cloneNode(true);
      target.append(actions);
    }
    if (root.matches('.honeypop-pp') && root.closest('.ks-purchase-ux')) {
      const form = root.closest('product-form')?.querySelector('form');
      if (form && form.nextElementSibling !== root) form.after(root);
      const summary = target.querySelector('p');
      const equivalent = summary?.querySelector('.honeypop-pp-value');
      const raw = equivalent?.textContent.trim();
      if (root.dataset.currency === 'TRY' && raw && /₺|TL/.test(raw)) {
        const digits = raw.replace(/[^\d.,]/g, '');
        const decimal = digits.match(/[.,](\d{1,2})$/);
        const whole = (decimal ? digits.slice(0, decimal.index) : digits).replace(/[.,]/g, '');
        const amount = Number(`${whole}.${decimal?.[1] || '00'}`);
        if (whole && Number.isFinite(amount)) {
          const label = `≈${money.format(amount)} TL`;
          if (equivalent.textContent !== label) equivalent.textContent = label;
        }
      }
      const points = summary?.textContent.match(/([\d.,]+)\s+Küp\s+Puan/)?.[1];
      const text = summary && [...summary.childNodes].find(node => node.nodeType === Node.TEXT_NODE);
      if (points && text) {
        const label = template.dataset.earnLabel.replace('[points]', points);
        if (text.nodeValue !== label) text.nodeValue = label;
        if (!target.querySelector('.ks-prime-explainer')) {
          const note = document.createElement('p');
          note.className = 'ks-prime-explainer';
          note.textContent = template.dataset.earnNote;
          target.insertBefore(note, actions);
        }
      }
    }
    makeStatic(root);
    const header = root.querySelector('.honeypop-cp-header');
    const panel = root.querySelector('.honeypop-cp-panel');
    const toggle = root.querySelector('.honeypop-cp-open');
    const restoreFocus = panel?.contains(document.activeElement) || toggle === document.activeElement;
    makeStatic(header);
    hide(panel);
    hide(toggle);
    if (toggle) attr(toggle, 'tabindex', '-1');
    root.querySelectorAll('.honeypop-pp-text a, .honeypop-cp-text a, .honeypop-pp-text button, .honeypop-pp-text [role="button"]').forEach((element) => {
      if (actions.contains(element)) return;
      if (element.tagName === 'BUTTON') hide(element);
      else if (element.tagName === 'A') {
        ['href', 'role', 'tabindex', 'aria-disabled'].forEach((name) => removeAttr(element, name));
      } else makeStatic(element);
    });
    if (restoreFocus) actions.querySelector('a').focus({ preventScroll: true });
  }

  function schedule(root) {
    pending.add(root);
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      pending.forEach((item) => { if (item.isConnected) decorate(item); });
      pending.clear();
    });
  }

  function observe(root) {
    if (roots.has(root)) return;
    const observer = new MutationObserver(() => schedule(root));
    observer.observe(root, {
      childList: true, subtree: true, characterData: true,
      attributes: true, attributeFilter: ['hidden', 'inert', 'role', 'tabindex', 'aria-hidden', 'href']
    });
    roots.set(root, observer);
    schedule(root);
  }

  function preventWidget(event) {
    if (!(event.target instanceof Element)) return;
    const root = event.target.closest(rootSelector);
    if (!root) return;
    const link = event.target.closest('a.ks-account-hub-link');
    if (link && root.contains(link)) {
      event.stopImmediatePropagation();
      return;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
  }
  window.addEventListener('click', preventWidget, true);
  window.addEventListener('auxclick', preventWidget, true);
  window.addEventListener('keydown', (event) => {
    if (!(event.target instanceof Element) || !event.target.closest(rootSelector)) return;
    if (event.key !== 'Enter' && event.key !== ' ') return;
    if (event.target.closest('a.ks-account-hub-link')) {
      event.stopImmediatePropagation();
      return;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);

  new MutationObserver((records) => {
    roots.forEach((observer, root) => {
      if (!root.isConnected) { observer.disconnect(); roots.delete(root); }
    });
    records.forEach((record) => {
      if (record.target instanceof Element && record.target.closest(rootSelector)) return;
      record.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;
        if (node.matches(rootSelector)) observe(node);
        node.querySelectorAll(rootSelector).forEach(observe);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
  document.querySelectorAll(rootSelector).forEach(observe);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ks-product-offers"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ks-product-offers')) {
    customElements.define('ks-product-offers', class extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.ks-purchase-ux');
        this.notice = this.querySelector('.ks-offer-notice');
        this.refresh = () => {
          this.querySelectorAll('.lb-spc-cont').forEach(card => {
            const name = card.querySelector('.lb-spc-details-name')?.textContent.trim();
            if (!name) return;
            const checkbox = card.querySelector('input[type="checkbox"]');
            if (checkbox) checkbox.setAttribute('aria-label', this.dataset.includeLabel.replace('[product]', name));
            card.querySelectorAll('select').forEach(select => {
              const option = select.querySelector('option[disabled]')?.textContent.trim() || '';
              select.setAttribute('aria-label', this.dataset.optionLabel.replace('[product]', name).replace('[option]', option));
            });
          });
          const selected = [...this.querySelectorAll('input[type="checkbox"]')].some(input => input.checked);
          this.querySelectorAll('.ppcse-tot-btn:not(button):not(input):not(a[href])').forEach(button => {
            button.setAttribute('role', 'button');
            button.setAttribute('tabindex', '0');
            button.setAttribute('aria-disabled', String(!selected));
            button.setAttribute('data-ks-keyboard-button', '');
          });
          let offered;
          for (const select of this.querySelectorAll('lb-product-page-cross-sell-ew select')) {
            try {
              const variant = JSON.parse(select.value);
              if (variant.isForProduct === true) { offered = variant; break; }
            } catch { /* seçilebilir sürümü olmayan satır atlanır */ }
          }
          const mainId = this.section.querySelector('product-form input[name="id"]')?.value;
          const mismatch = Boolean(offered && mainId && String(offered.id) !== mainId);
          if (this.hasAttribute('data-mismatch') !== mismatch) this.toggleAttribute('data-mismatch', mismatch);
          if (this.notice.hidden === mismatch) this.notice.hidden = !mismatch;
          this.offered = offered;
          if (!mismatch) return;
          const label = this.dataset.mismatchLabel.replace('[variant]', offered.title);
          const action = this.dataset.matchLabel.replace('[variant]', offered.title);
          const text = this.notice.querySelector('p');
          const button = this.notice.querySelector('button');
          if (text.textContent !== label) text.textContent = label;
          if (button.textContent !== action) button.textContent = action;
          const picker = this.section.querySelector('variant-radios');
          button.hidden = !picker || !offered.available;
        };
        this.onMatch = () => {
          const picker = this.section.querySelector('variant-radios');
          const variants = JSON.parse(picker?.querySelector('[type="application/json"]')?.textContent || '[]');
          const variant = variants.find(item => String(item.id) === String(this.offered?.id));
          if (!variant?.available) return;
          const fields = [...picker.querySelectorAll('fieldset')];
          variant.options.forEach((value, index) => {
            const input = [...fields[index].querySelectorAll('input[type="radio"]')].find(node => node.value === value);
            if (input && !input.checked) input.click();
          });
        };
        this.onKey = event => {
          const button = event.target.closest('[data-ks-keyboard-button]');
          if (!button || !this.contains(button) || !['Enter', ' '].includes(event.key)) return;
          event.preventDefault();
          event.stopPropagation();
          if (event.repeat || button.getAttribute('aria-disabled') === 'true' || button.hasAttribute('disabled') || this.hasAttribute('data-mismatch') || this.section.hasAttribute('data-ks-variant-loading')) return;
          if ((event.key === 'Enter' && event.type === 'keydown') || (event.key === ' ' && event.type === 'keyup')) button.click();
        };
        this.addEventListener('keydown', this.onKey);
        this.addEventListener('keyup', this.onKey);
        this.notice.querySelector('button').addEventListener('click', this.onMatch);
        this.addEventListener('change', this.refresh);
        this.observer = new MutationObserver(this.refresh);
        this.observer.observe(this, { childList: true, subtree: true });
        if (typeof subscribe === 'function') this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (data.sectionId === this.section.dataset.section) this.refresh();
        });
        this.refresh();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.unsubscribe?.();
        this.removeEventListener('change', this.refresh);
        this.removeEventListener('keydown', this.onKey);
        this.removeEventListener('keyup', this.onKey);
        this.notice?.querySelector('button')?.removeEventListener('click', this.onMatch);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ks-purchase-ux"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ks-purchase-support')) {
    customElements.define('ks-purchase-support', class extends HTMLElement {
      connectedCallback() {
        this.openChat = event => {
          if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const chat = document.querySelector('shopify-chat');
          if (typeof chat?.show !== 'function') return;
          event.preventDefault();
          event.stopPropagation();
          chat.show();
        };
        this.addEventListener('click', this.openChat);
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.openChat);
      }
    });
  }

  (() => {
    const init = (root = document) => root.querySelectorAll('.ks-purchase-ux .edd-widget').forEach(widget => {
      if (widget.dataset.ksClarity) return;
      widget.dataset.ksClarity = 'true';
      const copy = widget.closest('.ks-purchase-ux').querySelector('.ks-purchase-copy');
      const refresh = () => {
        const carrier = widget.querySelector('.edd-widget__carrier');
        const note = carrier?.querySelector('.edd-widget__note');
        if (!note || !copy) return;
        const free = [copy.dataset.freeMarker, copy.dataset.freeLabel].includes(note.textContent.trim());
        carrier.toggleAttribute('data-ks-free-shipping', free);
        if (free && note.textContent !== copy.dataset.freeLabel) note.textContent = copy.dataset.freeLabel;
        let brand = carrier.querySelector('.ks-carrier-brand');
        if (!brand) {
          const text = [...carrier.childNodes].filter(node => node.nodeType === Node.TEXT_NODE);
          const name = text.map(node => node.textContent).join('').trim();
          if (!name) return;
          brand = document.createElement('span');
          brand.className = 'ks-carrier-brand';
          if (/^DHL eCom(?:merce)?$/i.test(name)) {
            const image = document.createElement('img');
            image.src = copy.dataset.dhlLogo;
            image.alt = 'DHL eCommerce';
            image.width = 76;
            image.height = 23;
            brand.append(image);
          } else brand.textContent = name;
          text.forEach(node => node.remove());
          carrier.prepend(brand);
        }
      };
      new MutationObserver(refresh).observe(widget, { childList: true, subtree: true, characterData: true });
      refresh();
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
    else init();
    document.addEventListener('shopify:section:load', event => init(event.target));
  })();

  if (!customElements.get('ks-review-summary')) {
    customElements.define('ks-review-summary', class extends HTMLElement {
      connectedCallback() {
        this.observer = new MutationObserver(() => this.refresh());
        this.observer.observe(this, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['aria-label'] });
        this.refresh();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      refresh() {
        const ratingLabel = this.querySelector('.AirReviews-StarRate[aria-label]')?.getAttribute('aria-label') || '';
        const countLabel = this.querySelector('.AirReviews-StarRate--Count')?.textContent || '';
        const rating = Number(ratingLabel.match(/\d+(?:[.,]\d+)?/)?.[0]?.replace(',', '.'));
        const count = Number(countLabel.replace(/[^0-9]/g, ''));
        const link = this.querySelector('.ks-review-summary__link');
        if (!link || !(rating > 0 && rating <= 5 && count > 0)) {
          if (link && !link.hidden) link.hidden = true;
          if (this.hasAttribute('data-ready')) delete this.dataset.ready;
          return;
        }
        const locale = document.documentElement.lang || 'tr';
        const score = new Intl.NumberFormat(locale, { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(rating);
        const countText = this.dataset.countLabel.replace('[count]', new Intl.NumberFormat(locale).format(count));
        const scoreNode = link.querySelector('[data-ks-review-score]');
        const countNode = link.querySelector('[data-ks-review-count]');
        if (scoreNode.textContent !== score) scoreNode.textContent = score;
        if (countNode.textContent !== countText) countNode.textContent = countText;
        if (link.hidden) link.hidden = false;
        if (!this.hasAttribute('data-ready')) this.dataset.ready = '';
      }
    });
  }

  (() => {
    const init = () => {
      if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
      document.querySelectorAll('.ks-purchase-ux').forEach(section => {
        section.addEventListener('change', event => {
          const picker = event.target.closest('variant-radios');
          if (!picker) return;
          const pending = Boolean(picker.currentVariant);
          section.toggleAttribute('data-ks-variant-loading', pending);
          section.querySelector('[id^="price-"]')?.setAttribute('aria-busy', String(pending));
        });
      });
      subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        const section = document.getElementById(`MainProduct-${data.sectionId}`);
        if (!section?.classList.contains('ks-purchase-ux')) return;
        section.removeAttribute('data-ks-variant-loading');
        section.querySelector('[id^="price-"]')?.setAttribute('aria-busy', 'false');
        const area = section.querySelector('.ks-buy-area');
        const nextButton = data.html?.getElementById(`ProductSubmitButton-${data.sectionId}`);
        if (area && nextButton) area.dataset.ksAvailable = String(!nextButton.disabled);
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
    else init();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ks-restock-dialog"] && !Shopify.designMode) return;
  try {
    (() => {
    const init = () => {
      const skin = document.querySelector('.ks-purchase-ux .ks-restock-skin');
      if (!skin) return;
      const frames = new Map();
      let trigger;
      document.addEventListener('click', event => {
        const button = event.target.closest?.('.ks-purchase-ux .gw-button-widget');
        if (button) trigger = button;
      }, true);
      const applyFrame = frame => {
        if (frames.has(frame)) return;
        let disposeDocument = () => {};
        const state = {
          refresh: () => {},
          dispose: () => {
            frame.removeEventListener('load', onLoad);
            disposeDocument();
          }
        };
        frames.set(frame, state);
        const onLoad = () => {
          let doc;
          try { doc = frame.contentDocument; } catch { return; }
          if (!doc?.head || !doc.body || doc.documentElement.hasAttribute('data-ks-restock')) return;
          disposeDocument();
          doc.documentElement.setAttribute('data-ks-restock', '');
          doc.head.append(skin.content.cloneNode(true));
          const handledConsent = new WeakSet();
          const visible = element => Boolean(element?.getClientRects().length) && element.ownerDocument.defaultView.getComputedStyle(element).visibility !== 'hidden';
          const getModal = () => {
            const modal = doc.querySelector('.modal:not([v-cloak])');
            return frame.isConnected && visible(frame) && visible(modal) ? modal : null;
          };
          const focusable = modal => [...modal.querySelectorAll('a[href], button, input, select, textarea, [tabindex]')]
            .filter(element => element.tabIndex >= 0 && !element.matches(':disabled') && visible(element));
          let opened = false;
          let initialCopy = false;
          let wasCompleted = false;
          let returnTarget;
          const refresh = () => {
            const modal = getModal();
            if (!modal) {
              if (opened) {
                opened = false;
                initialCopy = false;
                wasCompleted = false;
                const target = returnTarget?.isConnected ? returnTarget : document.querySelector('.ks-purchase-ux .gw-button-widget');
                target?.focus({ preventScroll: true });
              }
              return;
            }
            const firstOpen = !opened;
            if (firstOpen) {
              opened = true;
              returnTarget = trigger?.isConnected ? trigger : document.activeElement;
            }
            const container = modal.querySelector('.modal-container') || modal;
            const title = modal.querySelector('.modal-title');
            const description = modal.querySelector('.notification-message');
            const email = modal.querySelector('.email-input');
            const success = modal.querySelector('.gw-success-message');
            const completed = visible(success);
            const becameCompleted = completed && !wasCompleted;
            wasCompleted = completed;
            if (!initialCopy && visible(email) && !completed) {
              if (title) title.textContent = skin.dataset.title;
              if (description) description.textContent = skin.dataset.description;
              initialCopy = true;
            }
            modal.setAttribute('aria-modal', 'true');
            container.setAttribute('tabindex', '-1');
            if (title) {
              if (!title.id) title.id = 'ks-restock-title';
              modal.setAttribute('aria-labelledby', title.id);
            }
            if (success) success.setAttribute('tabindex', '-1');
            const close = modal.querySelector('.close-icon');
            if (close) close.setAttribute('aria-label', skin.dataset.close);
            if (email) { email.setAttribute('aria-label', skin.dataset.email); email.setAttribute('type', 'email'); }
            const consent = modal.querySelector('#accepts_marketing');
            if (consent && !handledConsent.has(consent)) {
              handledConsent.add(consent);
              if (consent.checked) {
                consent.checked = false;
                consent.dispatchEvent(new doc.defaultView.Event('change', { bubbles: true }));
              }
            }
            if (firstOpen || becameCompleted || !modal.contains(doc.activeElement) || !visible(doc.activeElement)) {
              const target = completed ? success : visible(email) ? email : container;
              target.focus({ preventScroll: true });
            }
          };
          const onKeydown = event => {
            const modal = getModal();
            if (!modal || event.isComposing) return;
            if (event.key === 'Escape') {
              const close = [...modal.querySelectorAll('.action-close, .close-icon')].find(visible);
              if (!close) return;
              event.preventDefault();
              event.stopPropagation();
              close.click();
              refresh();
            } else if (event.key === 'Tab') {
              const targets = focusable(modal);
              const first = targets[0];
              const last = targets[targets.length - 1];
              const active = event.target.ownerDocument === doc ? doc.activeElement : null;
              if (!first || !targets.includes(active) || (event.shiftKey ? active === first : active === last)) {
                event.preventDefault();
                const target = (event.shiftKey ? last : first) || modal.querySelector('.modal-container') || modal;
                target.focus({ preventScroll: true });
              }
            }
          };
          doc.addEventListener('keydown', onKeydown, true);
          document.addEventListener('keydown', onKeydown, true);
          const observer = new MutationObserver(refresh);
          observer.observe(doc.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'hidden', 'v-cloak'] });
          const frameObserver = new MutationObserver(refresh);
          frameObserver.observe(frame, { attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
          state.refresh = refresh;
          disposeDocument = () => {
            observer.disconnect();
            frameObserver.disconnect();
            doc.removeEventListener('keydown', onKeydown, true);
            document.removeEventListener('keydown', onKeydown, true);
          };
          refresh();
        };
        frame.addEventListener('load', onLoad);
        onLoad();
      };
      const refresh = () => {
        const frame = document.getElementById('gw-stock-fulfilled-iframe');
        if (frame) applyFrame(frame);
        frames.forEach((state, current) => {
          state.refresh();
          if (!current.isConnected) {
            state.dispose();
            frames.delete(current);
          }
        });
        document.querySelectorAll('.ks-purchase-ux .gw-button-widget').forEach(button => {
          if (button.textContent.trim() !== skin.dataset.trigger) button.textContent = skin.dataset.trigger;
        });
      };
      new MutationObserver(refresh).observe(document.body, { childList: true, subtree: true });
      refresh();
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
    else init();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ks-variant-comparison"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ks-variant-comparison')) {
    customElements.define('ks-variant-comparison', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.dialog = this.querySelector('dialog');
        this.section = document.getElementById(`MainProduct-${this.dataset.sectionId}`);
        this.section?.addEventListener('click', (event) => {
          const link = event.target.closest('a.ks-compare-link');
          if (!link || !this.dialog.showModal || !this.build()) return;
          event.preventDefault();
          this.returnTarget = link;
          this.dialog.showModal();
        });
        this.querySelectorAll('[data-ks-close]').forEach(button => button.addEventListener('click', () => this.dialog.close()));
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        });
        this.dialog.addEventListener('close', () => this.returnTarget?.focus({ preventScroll: true }));
        this.dialog.addEventListener('keydown', event => {
          if (event.key !== 'Tab') return;
          const buttons = [...this.dialog.querySelectorAll('button:not(:disabled), summary')].filter(node => node.getClientRects().length);
          const first = buttons[0];
          const last = buttons[buttons.length - 1];
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
        });
      }

      build() {
        const source = document.getElementById(this.dataset.sourceId)?.closest('.ks-section');
        const tables = source?.querySelectorAll('table.ks-comparison');
        if (!tables?.length) return false;
        const content = this.querySelector('[data-ks-comparison-content]');
        content.replaceChildren();
        const picker = this.section.querySelector('variant-radios');
        const inputs = [...picker.querySelectorAll('input[type="radio"]')];
        const variants = JSON.parse(picker.querySelector('[type="application/json"]').textContent);
        const prices = this.querySelector('[data-ks-comparison-prices]').content;
        const resolve = input => {
          const fields = [...picker.querySelectorAll('fieldset')];
          const optionIndex = fields.indexOf(input.closest('fieldset'));
          const chosen = fields.map(field => field.querySelector('input:checked')?.value);
          chosen[optionIndex] = input.value;
          return variants.find(variant => variant.options.every((value, index) => value === chosen[index]));
        };
        const key = value => value.trim().replace(/\s+/g, ' ').toLocaleLowerCase(document.documentElement.lang || 'tr');
        const make = (tag, text, className) => {
          const node = document.createElement(tag);
          if (text) node.textContent = text;
          if (className) node.className = className;
          return node;
        };
        for (const table of tables) {
          const rows = [...table.rows].map(row => [...row.cells].map(cell => cell.textContent.trim()));
          if (rows.length < 2 || rows[0].length < 2) continue;
          const header = rows[0];
          const body = rows.slice(1);
          const rowMatch = body.some(row => inputs.some(input => key(input.value) === key(row[0])));
          const columnMatch = header.slice(1).some(name => inputs.some(input => key(input.value) === key(name)));
          let versions;
          if (rowMatch || /^(sürüm|versiyon|version|model|seçenek)$/i.test(header[0])) {
            versions = body.map(row => ({ name: row[0], facts: header.slice(1).map((name, index) => [name, row[index + 1] || '—']) }));
          } else if (columnMatch) {
            versions = header.slice(1).map((name, index) => ({ name, facts: body.map(row => [row[0], row[index + 1] || '—']) }));
          }
          if (!versions) {
            const wrap = make('div', '', 'ks-comparison-dialog__table');
            const copy = make('table');
            if (table.caption) copy.append(make('caption', table.caption.textContent));
            rows.forEach((row, index) => {
              const tr = make('tr');
              row.forEach(value => tr.append(make(index ? 'td' : 'th', value)));
              copy.append(tr);
            });
            wrap.append(copy);
            content.append(wrap);
            continue;
          }
          const overview = make('div', '', 'ks-comparison-overview');
          const details = make('details', '', 'ks-comparison-details');
          details.append(make('summary', this.dataset.detailsLabel));
          const cards = make('div', '', 'ks-comparison-cards');
          versions.forEach(version => {
            const card = make('article', '', 'ks-comparison-card');
            card.append(make('h3', version.name));
            const facts = make('dl');
            version.facts.forEach(([name, value]) => {
              const row = make('div');
              row.append(make('dt', name), make('dd', value));
              facts.append(row);
            });
            card.append(facts);
            const matches = inputs.filter(input => key(input.value) === key(version.name));
            if (matches.length === 1) {
              const input = matches[0];
              const variant = resolve(input);
              const unavailable = !variant?.available || input.classList.contains('disabled');
              if (input.checked) card.dataset.selected = '';
              const select = make('button', unavailable ? this.dataset.unavailableLabel : input.checked ? this.dataset.selectedLabel : this.dataset.selectLabel);
              select.type = 'button';
              select.disabled = unavailable;
              select.setAttribute('aria-label', `${version.name}: ${select.textContent}`);
              select.addEventListener('click', () => {
                input.click();
                this.returnTarget = input;
                this.dialog.close();
                input.closest('fieldset').scrollIntoView({ block: 'center' });
              });
              card.append(select);
            } else {
              const back = make('button', this.dataset.backLabel);
              back.type = 'button';
              back.addEventListener('click', () => this.dialog.close());
              card.append(back);
            }
            cards.append(card);
          });
          const baseName = value => value.replace(/\s+\((?:Robot|Klasik) stand ile\)$/i, '');
          const group = inputs.find(input => versions.some(version => key(version.name) === key(baseName(input.value))))?.closest('fieldset');
          const optionInputs = group ? [...group.querySelectorAll('input[type="radio"]')] : [];
          optionInputs.forEach(input => {
            const variant = resolve(input);
            const price = variant && prices.querySelector(`[data-variant-id="${variant.id}"]`);
            const unavailable = !variant?.available || input.classList.contains('disabled');
            const action = unavailable ? this.dataset.unavailableLabel : input.checked ? this.dataset.selectedLabel : this.dataset.selectLabel;
            let matches = versions.filter(version => key(version.name) === key(input.value));
            if (!matches.length && this.dataset.sourceId === 'ks-rs3-versions') matches = versions.filter(version => key(version.name) === key(baseName(input.value)));
            const version = matches.length === 1 ? matches[0] : { facts: [] };
              if (price) {
                const option = make('button', '', 'ks-comparison-option');
                option.type = 'button';
                option.disabled = unavailable;
                option.setAttribute('aria-pressed', String(input.checked));
                option.setAttribute('aria-label', `${input.value}, ${price.textContent.trim()}, ${unavailable ? this.dataset.unavailableLabel : price.dataset.stock}. ${action}`);
                option.append(make('span', input.value, 'ks-comparison-option__name'));
                const meta = make('span', '', 'ks-comparison-option__meta');
                meta.append(make('strong', price.textContent.trim(), 'ks-comparison-option__price'));
                const availability = make('span');
                availability.append(make('span', unavailable ? this.dataset.unavailableLabel : price.dataset.stock, 'ks-comparison-option__stock'));
                if (!unavailable) availability.append(make('span', input.checked ? this.dataset.currentLabel : this.dataset.chooseLabel, 'ks-comparison-option__action'));
                meta.append(availability);
                option.append(meta);
                let differences = version.facts.filter(([name]) => new Set(versions.map(item => item.facts.find(fact => fact[0] === name)?.[1])).size > 1);
                const coreFacts = differences.filter(([name]) => !/ağırlık|boyut|ölçü|toplam|weight|size|total/i.test(name));
                differences = (coreFacts.length ? coreFacts : differences).slice(0, 3);
                let summary = differences.map(([name, value]) => {
                  if (/^(dış yüzey|yüzey)$/i.test(name)) return this.dataset.surfaceLabel.replace('[value]', value);
                  if (/^(merkez esnemesi|esneme sistemi)$/i.test(name)) {
                    if (/^(metal )?yay$/i.test(value)) return this.dataset.springLabel;
                    if (/^maglev$/i.test(value)) return this.dataset.maglevLabel;
                  }
                  if (/^çekirdek mıknatısı$/i.test(name)) return /^yok$/i.test(value) ? this.dataset.coreNoneLabel : this.dataset.coreLabel.replace('[value]', value);
                  return `${name}: ${value}`;
                }).join(' · ');
                if (this.dataset.sourceId === 'ks-rs3-versions') {
                  const briefKeys = { 'Standart': 'rs3Basic', 'Yay Ayarlı': 'rs3Adjustable', 'Maglev': 'rs3Maglev', 'Ball-Core + UV Kaplama': 'rs3Core' };
                  summary = this.dataset[briefKeys[baseName(input.value)]] || summary;
                }
                option.append(make('span', summary, 'ks-comparison-option__summary'));
                option.addEventListener('click', () => {
                  input.click();
                  this.returnTarget = input;
                  this.dialog.close();
                  input.closest('fieldset').scrollIntoView({ block: 'center' });
                });
                overview.append(option);
              }
          });
          if (overview.childElementCount) content.append(make('p', this.dataset.summaryLabel, 'ks-comparison-dialog__intro'), overview);
          details.append(cards);
          content.append(details);
        }
        source.querySelectorAll(':scope > p').forEach(p => {
          if (/yatay kaydır|scroll horizontally/i.test(p.textContent)) return;
          content.append(make('p', p.textContent, 'ks-comparison-dialog__note'));
        });
        return content.childElementCount > 0;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
